import React from "react";

const NoPrograms: React.FC<{ handleCreateProgram: () => void }> = ({
  handleCreateProgram,
}) => {
  return (
    <div className="text-center text-gray-500 items-center justify-center flex-1 flex flex-col space-y-8">
      <img src="/no_program.svg" className="w-36 mb-4" alt="" />
      <div>
        <p className="text-gray-800 font-semibold">No programs created yet.</p>
        <p className="text-gray-400">
          Programs help you organize and manage multiple related projects.{" "}
          <br />
          Create your first program to get started.
        </p>
      </div>
      <button
        onClick={handleCreateProgram}
        className="bg-blue-600 text-white rounded hover:bg-blue-500 transition px-4  py-2 flex justify-center items-center space-x-2"
      >
        <span>+</span>
        <span>Create Your First Program</span>
      </button>
    </div>
  );
};

export default NoPrograms;
